/**
 * ProgressBar component
 * Displays a horizontal progress bar with percentage fill
 * Used in session cards to show session completion progress
 */

import { cn } from '@/lib/utils';

export interface ProgressBarProps {
  /** Progress value from 0 to 100 */
  value: number;
  /** Optional additional class names */
  className?: string;
}

/**
 * ProgressBar - Horizontal progress indicator with ThinkOtter orange fill
 */
export function ProgressBar({ value, className }: ProgressBarProps) {
  // Clamp value between 0 and 100, handle invalid inputs
  const clampedValue = Math.min(100, Math.max(0, Number(value) || 0));

  return (
    <div
      className={cn('w-full bg-gray-200 rounded-full h-2', className)}
      role="progressbar"
      aria-valuenow={clampedValue}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="bg-otter-orange-500 h-2 rounded-full transition-all duration-300"
        style={{ width: `${clampedValue}%` }}
      />
    </div>
  );
}
